<template>
  <div class="home">
    <!-- 請求狀態-載入中 -->
    <RequestLoading v-if="requestStatus === 1" />
    <!-- 請求狀態-超時 -->
    <RequestTimeOut v-if="requestStatus === 2" />
    <!-- 請求狀態-報錯 -->
    <RequestError v-if="requestStatus === 3" />
  </div>
</template>

<script>
// 此處可以直接使用jquery $
// import $ from 'jquery'
import RequestLoading from "./components/RequestLoading.vue";
import RequestTimeOut from "./components/RequestTimeOut.vue";
import RequestError from "./components/RequestError.vue";
export default {
  name: "Home",
  components: {
    RequestLoading,
    RequestTimeOut,
    RequestError,
  },
  data() {
    return {
      // 1載入中 2超時 3報錯 默認載入中
      requestStatus: 1,
      Classkey: "",
    };
  },
  async created() {
    // 做一個三秒的加載動畫 模擬API請求
    await this.init();
    // setTimeout(() => {
    //   this.pageRedirect();
    // }, 5000);
  },
  mounted() {
    window.addEventListener("hashchange", function () {
      this.window.location.reload();
    });
  },
  methods: {
    beforeJoinClass() {
      new Promise(async (resolve, reject) => {
        try {
          await this.$store.dispatch("joinNewClassHitutor", {
            ClassKey: `${this.Classkey}`,
          });
          this.$store.commit("setClassRoomKey", this.ClassKey);
          resolve();
        } catch (error) {
          this.requestStatus = 3
          reject(error);
        }
      }).then(() => {
        this.pageRedirect();
      });
    },
    // 頁面進入初始化 模擬假數據
    async init() {
      // 獲取路由的key 進行身份判定 此處使用 1老師 2學生 3客服 4家長 5請求超時 6請求異常
      const key = this.$route.query.key;
      this.Classkey = key;
      console.log(this.Classkey);
      // 保存到瀏覽器儲存
      if (key) {
        sessionStorage.setItem("key", key);
        // 清除上一次登入留下的 userType / classroomId，
        // 避免本次加入中途失敗時 pageRedirect() 讀到舊值跳轉到教室，
        // 觸發路由守衛的重定向循環而卡在載入中畫面
        sessionStorage.removeItem("userType");
        sessionStorage.removeItem("classroomId");

        this.beforeJoinClass();
      }
    },
    pageRedirect() {
      // 根據權限跳轉頁面

      var userType = sessionStorage.getItem("userType");
      if (userType === null) {
        console.log("The key 'userType' does not exist in sessionStorage.");
      } else if (userType === "") {
        console.log(
          "The key 'userType' exists in sessionStorage but its value is empty."
        );
      } else {
        console.log(
          "The key 'userType' exists in sessionStorage and its value is:",
          userType
        );
      }
      // alert(userType)
      if (userType == 0) {
        this.$router.push({ path: "/student" }).catch(() => {});
      } else if (userType == 1) {
        this.$router.push({ path: "/teacher" }).catch(() => {});
      } else if (userType == 2) {
        this.$router.push({ path: "/employee" }).catch(() => {});
      } else if (userType == 3) {
        this.$router.push({ path: "/observation" }).catch(() => {});
      } else if (userType == 4) {
        this.requestStatus = 2;
      } else {
        this.requestStatus = 3;
      }
    },
    checkUserTypeAndContinue() {
      var checkInterval = setInterval(() => {
        var userType = sessionStorage.getItem("userType");
        if (userType !== null) {
          clearInterval(checkInterval);
          this.continueFunction();
        }
      }, 100);
    },
    continueFunction() {
      this.pageRedirect();
    }
  },
};
</script>
